export default __webpack_public_path__ + "static/Live_Cams_03-12fcaf78eff97e119ec4b887c94bc257.webp";